import ContentPage from "./ContentPage";

export default function Privacy() {
  return (
    <ContentPage title="Privacy policy" eyebrow="Legal">
      <p className="lead">
        This placeholder summarizes how a storefront typically handles personal data. Replace with counsel-reviewed text before production.
      </p>
      <p>
        We collect information you provide when you create an account, place an order, or contact us. We use this information to fulfill orders, communicate with you, and improve our services.
      </p>
      <p>
        We do not sell your personal information. Service providers may process data on our behalf under strict agreements.
      </p>
    </ContentPage>
  );
}
